const timelineData = [
    {
        id: 1,
        title: "DAV Public school",
        location: "Sector-6, CDA",
        description: "I was studying here 2006 to 2018 and obtained my basic education from here.",
        buttonText:"View Website",
        date:"2006 - 2018",
        icon:"school",
        link:"http://davcda.org/"
    },
    {
        id: 2,
        title: "Ravenshaw University",
        location: "Cuttack, Odisha",
        description: "I took my higher education from here.",
        buttonText:"View Website",
        date:"2018 - 2020",
        icon:"school",
        link:"https://ravenshawuniversity.ac.in/"
    },
    {
        id: 3,
        title: "NIT Rourkela",
        location: "Cuttack, Odisha",
        description: "I am persuading my undergrad here in Electrical Engineering.",
        buttonText:"View Website",
        date:"November 2020 - present",
        icon:"school",
        link:"https://www.nitrkl.ac.in/"
    },
    {
        id: 4,
        title: "frontend Developer",
        location: "Cuttack, Odisha",
        description: "After getting fascinated by web development started learning it and still learning.",
        buttonText:"View Projects",
        date:"April 2021 - present",
        icon:"work",
        link:"/project"
    },
    {
        id: 5,
        title: "POSTman api fest 2022",
        location: "Cuttack, Odisha",
        description: "After getting inspired by apis joined postman's API Fest. There with random teammates secured top 10.",
        buttonText:"View Projects",
        date:"January 2022",
        icon:"work",
        link:"/project"
    },
    {
        id: 6,
        title: "Backend Developer",
        location: "Cuttack, Odisha",
        description: "A major part of wev development is backend. I started learning it recently and still learning.",
        buttonText:"View Projects",
        date:"March 2022 - present",
        icon:"work",
        link:"/project"
    },
]

export {timelineData} ;